/* Escarcha Cero — JS del tema (sin dependencias) */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Utilidades ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount_with_comma_separator}} €';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? '.' : thousands;
      decimal = decimal == null ? ',' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2, '.', ','); break;
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function trackAddToCart(items, valueCents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var value = valueCents / 100;
    var ids = items.map(function (i) { return String(i.id); });
    try { if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: ids, content_type: 'product', value: value, currency: currency }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'add_to_cart', { currency: currency, value: value, items: items.map(function (i) { return { item_id: String(i.id), quantity: i.quantity }; }) }); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ec_add_to_cart', ecommerce: { currency: currency, value: value, items: items } }); } catch (e) {}
  }

  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'No se ha podido añadir al carrito.');
        return data;
      });
    });
  }

  function refreshCartCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ec-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Producto ---------- */
  function initProduct(section) {
    var form = section.querySelector('[data-ec-form]');
    if (!form) return;
    var variantsEl = section.querySelector('[data-ec-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var offerIndex = parseInt(section.getAttribute('data-offer-index'), 10);
    var showCompare = section.getAttribute('data-show-compare') === 'true';
    var afterAdd = section.getAttribute('data-after-add') || 'cart';
    var moneyFormat = (window.ecProduct && window.ecProduct.moneyFormat) || undefined;
    var input = form.querySelector('[data-ec-variant-input]');
    var submit = form.querySelector('[data-ec-submit]');
    var submitLabel = form.querySelector('[data-ec-submit-label]');
    var defaultLabel = submitLabel ? submitLabel.textContent : '';
    var errorEl = form.querySelector('[data-ec-error]');
    var qtyInput = form.querySelector('[data-ec-qty-input]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-ec-offer]'));
    var pickers = Array.prototype.slice.call(section.querySelectorAll('[data-ec-picker]'));

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }
    var current = findVariant(parseInt(input.value, 10)) || variants[0];

    function syncCardClasses() {
      cards.forEach(function (c) {
        var r = c.querySelector('input');
        c.classList.toggle('is-checked', !!(r && r.checked));
      });
    }

    function render(v) {
      if (!v) return;
      current = v;
      input.value = v.id;
      var price = section.querySelector('[data-ec-price]');
      var compare = section.querySelector('[data-ec-compare]');
      var saving = section.querySelector('[data-ec-saving]');
      if (price) price.textContent = formatMoney(v.price, moneyFormat);
      var hasCompare = showCompare && v.compare_at_price && v.compare_at_price > v.price;
      if (compare) { compare.hidden = !hasCompare; if (hasCompare) compare.textContent = formatMoney(v.compare_at_price, moneyFormat); }
      if (saving) {
        saving.hidden = !hasCompare;
        if (hasCompare) {
          var diff = v.compare_at_price - v.price;
          saving.querySelector('[data-ec-saving-amount]').textContent = formatMoney(diff, moneyFormat);
          saving.querySelector('[data-ec-saving-pct]').textContent = Math.round((diff * 100) / v.compare_at_price);
        }
      }
      var sticky = section.querySelector('[data-ec-sticky-price]');
      if (sticky) sticky.textContent = formatMoney(v.price, moneyFormat);
      if (submit) {
        submit.disabled = !v.available;
        if (submitLabel) submitLabel.textContent = v.available ? defaultLabel : 'Agotado';
      }
      if (window.ecProduct) { window.ecProduct.variantId = v.id; window.ecProduct.price = v.price / 100; }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      syncCardClasses();
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('input');
      radio.addEventListener('change', function () {
        if (radio.checked) render(findVariant(parseInt(radio.value, 10)));
      });
    });

    pickers.forEach(function (picker) {
      var idx = parseInt(picker.getAttribute('data-option-index'), 10);
      picker.addEventListener('change', function (e) {
        var value = e.target.value;
        var label = picker.querySelector('[data-ec-picker-value]');
        if (label) label.textContent = value;
        var wanted = current.options.slice();
        wanted[idx] = value;
        // Muestra solo las tarjetas que coinciden con las demás opciones
        var candidates = variants.filter(function (v) {
          return v.options.every(function (o, i) { return i === offerIndex || o === wanted[i]; });
        });
        cards.forEach(function (card) {
          var id = parseInt(card.getAttribute('data-variant-id'), 10);
          card.hidden = !candidates.some(function (v) { return v.id === id; });
        });
        var next = candidates.filter(function (v) { return offerIndex < 0 || v.options[offerIndex] === wanted[offerIndex]; })[0] || candidates[0];
        if (next) {
          cards.forEach(function (card) {
            var r = card.querySelector('input');
            r.checked = parseInt(r.value, 10) === next.id;
          });
          render(next);
        }
      });
    });

    // Cantidad
    var minus = form.querySelector('[data-ec-qty-minus]');
    var plus = form.querySelector('[data-ec-qty-plus]');
    function setQty(n) { if (!qtyInput) return; n = Math.max(1, Math.min(10, n || 1)); qtyInput.value = n; }
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });

    // Complemento
    var addon = form.querySelector('[data-ec-addon-input]');
    if (addon) addon.addEventListener('change', function () { addon.closest('[data-ec-addon]').classList.toggle('is-checked', addon.checked); });

    // Envío del formulario
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // sin JS moderno: envío normal a /cart/add
      e.preventDefault();
      if (!current || !current.available) return;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var items = [{ id: current.id, quantity: qty }];
      var value = current.price * qty;
      if (addon && addon.checked) { items.push({ id: parseInt(addon.value, 10), quantity: 1 }); }
      if (errorEl) errorEl.hidden = true;
      submit.classList.add('is-loading');
      addToCart(items)
        .then(function (data) {
          var added = (data && data.items) || [];
          var total = added.reduce(function (s, i) { return s + (i.final_line_price || i.line_price || 0); }, 0) || value;
          trackAddToCart(items, total);
          window.location.href = afterAdd === 'checkout' ? root + 'checkout' : root + 'cart';
        })
        .catch(function (err) {
          submit.classList.remove('is-loading');
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        });
    });

    // Barra fija móvil
    var sticky = section.querySelector('[data-ec-sticky]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      document.body.classList.add('ec-has-sticky');
      var footer = document.querySelector('.ec-footer');
      var submitVisible = true;
      var footerVisible = false;
      var update = function () {
        var passed = submit.getBoundingClientRect().top < 0;
        var show = !submitVisible && passed && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var btn = sticky.querySelector('[data-ec-sticky-btn]');
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) { submitVisible = entries[0].isIntersecting; update(); }).observe(submit);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
      window.addEventListener('scroll', update, { passive: true });
      sticky.querySelector('[data-ec-sticky-btn]').addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
        else submit.click();
      });
    }

    syncCardClasses();
  }

  /* ---------- Galería ---------- */
  function initGallery(gallery) {
    var track = gallery.querySelector('[data-ec-gallery-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = gallery.querySelectorAll('[data-ec-thumb]');
    var dots = gallery.querySelectorAll('.ec-gallery__dot');
    function setActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-ec-thumb'), 10);
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Enlaces a la zona de compra ---------- */
  function initScrollLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-ec-scroll-buy]');
      if (!link) return;
      var target = document.querySelector('[data-ec-offers]') || document.getElementById('ec-comprar');
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.ec-header');
      var offset = (header ? header.offsetHeight : 0) + 16;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
    });
  }

  /* ---------- Añadir rápido (upsell) ---------- */
  function initQuickAdd(scope) {
    (scope || document).querySelectorAll('[data-ec-quick-add]').forEach(function (btn) {
      if (btn.dataset.ecBound) return;
      btn.dataset.ecBound = '1';
      btn.addEventListener('click', function () {
        var id = parseInt(btn.getAttribute('data-ec-quick-add'), 10);
        var label = btn.querySelector('[data-ec-quick-label]');
        var err = btn.parentElement.querySelector('[data-ec-quick-error]');
        var original = label.textContent;
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        addToCart([{ id: id, quantity: 1 }])
          .then(function (data) {
            var items = (data && data.items) || [];
            trackAddToCart([{ id: id, quantity: 1 }], items.length ? items[0].final_line_price : 0);
            btn.classList.remove('is-loading');
            label.textContent = 'Añadido ✓';
            refreshCartCount();
            setTimeout(function () { label.textContent = original; }, 2500);
          })
          .catch(function (e) {
            btn.classList.remove('is-loading');
            if (err) { err.textContent = e.message; err.hidden = false; }
          });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ec-product]').forEach(initProduct);
    document.querySelectorAll('[data-ec-gallery]').forEach(initGallery);
    initScrollLinks();
    initQuickAdd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-inicializa al editar en el personalizador de temas
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ec-product]').forEach(initProduct);
    e.target.querySelectorAll('[data-ec-gallery]').forEach(initGallery);
    initQuickAdd(e.target);
  });
})();
